import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://api.abhapublication.com/api';

const api = axios.create({
    baseURL: API_URL,
    headers: {
        'Content-Type': 'application/json',
    },
    timeout: 10000,
});

// Request interceptor - Add token to every request
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        console.log('API Request - Token exists:', !!token);
        
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        console.error('API Request Error:', error);
        return Promise.reject(error);
    }
);

// Response interceptor - Handle token errors
api.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        console.error('API Response Error:', error.response?.status, error.response?.data);

        // If unauthorized (401), clear token and redirect to login
        if (error.response?.status === 401) {
            // Single-device login kicked this token out (someone logged in
            // elsewhere) — same clear+redirect as any other 401, but with a
            // message that actually explains why, instead of just bouncing
            // the user to /login with no context.
            if (error.response?.data?.code === 'SESSION_INVALIDATED') {
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                alert('Aap kisi aur device par login ho gaye hain. Dobara login karein.');
                window.location.href = '/login';
                return Promise.reject(error);
            }

            console.log('Unauthorized - Clearing token');
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

export default api;